var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel-wraper"},[_c('p',{staticClass:"panel-text"},[_vm._v("您尚未开通销售线索的权限")]),_c('div',{staticClass:"panel-icon"},[_c('img',{attrs:{"src":_vm.url,"alt":"图像加载失败"}})]),_c('p',{staticClass:"panel-content"},[_vm._v(_vm._s(_vm.content))]),_c('p',{staticClass:"panel-text"},[_vm._v("联系商务，我们告诉您")])])
}
var staticRenderFns = []

export { render, staticRenderFns }